<template>
  <div>
    <a-drawer
      :width="900"
      :visible="showCreateForm"
      :body-style="{ paddingBottom: '15px', paddingTop: '15px' }"
      class="create-project-page"
      @close="close"
    >
      <a-form-model ref="form" :model="model" :rules="rules" >
        <a-spin :spinning="loading" tip="Loading..." size="large" />

        <a-steps type="navigation" size="small" :current="current">
          <a-step v-for="item in steps" :key="item.title" :title="item.title" />
        </a-steps>


         <!-- 计划设置 -->
        <div class="step" v-if="current === 0">
          <a-form-model-item label="广告主" prop="ids">
            <adv-select v-model="model.ids" :max-tag-count="5" type="baidu" @blur="changeAdvs"/>
          </a-form-model-item>

          <a-form-model-item prop="name" label="任务名称">
            <a-input v-model="model.name"  />
          </a-form-model-item>

          <a-form-model-item prop="campaignFeedName" label="计划名称">
            <a-input v-model="model.campaignFeedName"  />
          </a-form-model-item>

          <a-form-model-item label="计划状态" prop="pause">
            <a-switch v-model="model.pause" />
          </a-form-model-item>
  
          <a-form-model-item label="营销目标" prop="subject">
            <a-radio-group v-model="model.subject">
              <a-radio-button :value="item.id" v-for="item in subjects" :key="item.id" :disabled="item.id!=model.subject">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="出价模式" prop="price_type" help="常规出价：旧版单元层出价模式，非加白账户只能使用常规出价 ">
            <a-radio-group v-model="model.price_type">
              <a-radio-button :value="item.id" v-for="item in price_types" :key="item.id" :disabled="item.id!=model.price_type">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="计划类型" prop="campaignType">
            <a-radio-group v-model="model.campaignType">
              <a-radio-button :value="item.id" v-for="item in campaignTypes" :key="item.id" :disabled="item.id!=model.campaignType">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="预算" prop="budget_model">
            <a-radio-group v-model="model.budget_model">
              <a-radio-button :value="item.id" v-for="item in budget_models" :key="item.id">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
  
          <a-form-model-item v-if="model.budget_model==2" label="" prop="budget" help="最小预算为50元">
            <a-input-number v-model="model.budget"  suffix="元/天" />
          </a-form-model-item>
          

          <a-form-model-item label="推广日期" prop="tgdate_model">
            <a-radio-group v-model="model.tgdate_model">
              <a-radio-button :value="item.id" v-for="item in tgdate_models" :key="item.id">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
  
          <a-form-model-item v-if="model.tgdate_model!=1" label="" prop="tg_date">
            <a-range-picker v-model="model.tg_date" valueFormat="YYYY-MM-DD" />
          </a-form-model-item>
  
          <a-form-model-item label="暂停时段" prop="zt_model">
            <a-radio-group v-model="model.zt_model">
              <a-radio-button :value="item.id" v-for="item in zt_models" :key="item.id">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>
  
          <a-form-model-item v-if="model.zt_model!=1" label="" prop="schedule">
            <byted-schedule v-model="model.schedule"  @change="scheduleChange" type="senior">
              <span slot="header"></span>
            </byted-schedule>
          </a-form-model-item>

        </div>

        <!-- 推广单元 -->
        <div class="step" v-if="current === 1">
          <a-form-model-item prop="adgroupFeedName" label="单元名称">
            <a-input v-model="model.adgroupFeedName"  />
          </a-form-model-item>

          <a-form-model-item label="单元状态" prop="adgroupFeedPause">
            <a-switch v-model="model.adgroupFeedPause" />
          </a-form-model-item>

          <a-form-model-item label="单元流量" prop="group_ftypes_model">
            <a-radio-group  v-model="model.group_ftypes_model">
              <a-radio-button :value="item.id" v-for="item in group_ftype_models" :key="item.id" :disabled="item.id!=model.group_ftypes_model">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item v-if="model.group_ftypes_model == 1" label="投放范围" prop="ftypes_model">
            <a-radio-group v-model="model.ftypes_model">
              <a-radio-button :value="item.id" v-for="item in ftype_models" :key="item.id">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="流量范围" v-if="model.ftypes_model == 3" prop="ftypesSelect">
            <byted-checkbox-group v-model="model.ftypesSelect" >
              <byted-checkbox-button v-for="ftype in ftypes" :val="ftype.id" :key="ftype.id" >
                {{ ftype.name }}
              </byted-checkbox-button>
            </byted-checkbox-group>
          </a-form-model-item>

          <a-form-model-item label="定向包" prop="atpId" >
            <a-select show-search allow-clear placeholder="请选择定向包" v-model="atpId" @change="changeAtp"
              option-filter-prop="children">
              <a-select-option :value="item.id" v-for="(item,index) in atpFeeds" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item v-if="apt_feed_data" label="" prop="atpId" >
              <a-collapse @change="changeDXB">
                <a-collapse-panel key="1" header="定向包详情（点击展开）">
                  <atp-feed label="定向包详情" prop="atpId" :model.sync="apt_feed_data"  ref="atpFeedRef"/>
                </a-collapse-panel>
              </a-collapse>
          </a-form-model-item>

          <a-form-model-item label="单元出价" prop="bidSource">
            <a-radio-group v-model="model.bidSource" >
              <a-radio-button :value="item.id" v-for="item in bidSources" :key="item.id" :disabled="item.id!=model.bidSource">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="投放范围" prop="bidtype" >
            <a-radio-group v-model="model.bidtype_model">
              <a-radio-button :value="item.id" v-for="item in bidtypes" :key="item.id" :disabled="item.id!=model.bidtype_model">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="出价方式" prop="bidtype" >
            <a-radio-group v-model="model.price_model">
              <a-radio-button :value="item.id" v-for="item in price_models" :key="item.id" >
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item v-if="model.price_model === 1" label="目标转化出价" prop="ocpc_bid" help="最小出价为0.3元，系统支持本出价模式进行成本保障与超额赔付">
            <a-input v-model="model.ocpc_bid" suffix="元/转化" />
          </a-form-model-item>

          <a-form-model-item v-else label="出价范围" help="最小出价为0.3元">
            <a-row>
              <a-col :span="10">
                <a-form-model-item  prop="ocpc_bid_min" >
                  <a-input v-model="model.ocpc_bid_min" addon-after="元/转化" placeholder="最低出价"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="10" style="margin-left:10px">
                <a-form-model-item  prop="ocpc_bid_max" >
                  <a-input v-model="model.ocpc_bid_max" addon-after="元/转化" placeholder="最高出价"/>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model-item>

        </div>

        <!-- 落地页设置 -->
        <div class="step" v-if="current === 2">
          <a-collapse v-model="model.ids" >
            <a-collapse-panel v-for="advertiser in advs" :key="advertiser.id.toString()" :header="'子账户：'+advertiser.name">
              <p>
                <a-form-model-item label="转化目标配置" >
                    <a-select show-search allow-clear placeholder="请选择转化" v-model="advertiser.appTransId" @change="changeOcpcTransFeeds"
                    option-filter-prop="children" >
                      <a-select-option :value="advertiser.id + '|' + ocpcTransFeed.appTransId + '|' + index + '|' + ocpcTransFeed.transFrom"
                        v-for="(ocpcTransFeed, index) in advertiser.ocpcTransFeeds" :key="index" :advertiser_id="advertiser.id" :ocpcTransFeed="ocpcTransFeed">
                        {{ ocpcTransFeed.transName }}
                      </a-select-option>
                    </a-select>

                    <a-select style="margin-top: 5px;" show-search allow-clear placeholder="请选择目标转化" v-model="advertiser.transType" 
                      option-filter-prop="children">
                      <a-select-option :value="item" v-for="(item, index) in transTypesForm[advertiser.appTransId]" :key="index">
                        {{ $helper.getItemName(trans_types, item) }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>

                <a-form-model-item label="落地页信息" prop="url">
                    <a-input-group compact>
                      <a-select :default-value="advertiser.url ? advertiser.url.substring(0, advertiser.url.indexOf('?')) : '选择已有页面' "  @change="changePage" :dropdownMatchSelectWidth="false" style="width:150px">
                        <a-select-option :value="item.onlineUrl" v-for="item in advertiser.pages" :key="item.pageId" :advertiser_id="advertiser.id" >
                          {{ item.pageName }}
                        </a-select-option>
                      </a-select>
                      <a-input style="width: 80%" v-model="advertiser.url" />
                    </a-input-group>
                </a-form-model-item>

                <a-input placeholder="监测链接"  v-model="advertiser.monitorUrl" style="margin-top: 10px;"/>
              </p>
            </a-collapse-panel>
          </a-collapse>
        </div>

        <!-- 创意设置 -->
        <div class="step" v-if="current === 3">
          <a-form-model-item prop="creativeFeedName" label="创意名称">
            <a-input v-model="model.creativeFeedName"  />
          </a-form-model-item>

          <a-form-model-item label=" 分配策略" prop="allocation_type" help="素材物料随机打散分配到各账户上">
            <a-radio-group  v-model="model.allocation_type">
              <a-radio-button :value="item.id" v-for="item in allocation_types" :key="item.id" :disabled="item.id!=model.allocation_type">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="创意方式" prop="ideaType">
            <a-radio-group v-model="model.ideaType">
              <a-radio-button :value="item.id" v-for="item in ideaTypes" :key="item.id" :disabled="item.id!=model.ideaType">
                {{ item.name }}
              </a-radio-button>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="计划数" prop="campaign_feed_num">
             <a-input v-model="model.campaign_feed_num" addon-after="个计划"/>
          </a-form-model-item>

          <a-form-model-item label="单元数" prop="adgroup_feed_num">
            <a-input v-model="model.adgroup_feed_num" addon-after="个单元"/>
           </a-form-model-item>

           <a-form-model-item label="创意组配置">
              <a-row>
                <a-col :span="7">
                  <a-form-model-item  prop="video_num" >
                    <a-input v-model="model.video_num" addon-after="个视频" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" style="margin-left:10px">
                  <a-form-model-item>
                    <a-input v-model="model.picture_num" addon-after="个图片" disabled/>
                  </a-form-model-item>
                </a-col>
                <a-col :span="7" style="margin-left:10px">
                  <a-form-model-item>
                    <a-input v-model="model.three_picture_num" addon-after="个三图" disabled/>
                  </a-form-model-item>
                </a-col>
              </a-row>
           </a-form-model-item>

           <a-form-model-item label="文案素材标题" prop="titles">
              <code-input ref="title_group" class="title-group" v-model="model.titles" />
              <div >
                <span>多个标题可按回车分隔，也可以批量导入 </span>
                <a-select show-search allow-clear placeholder="标题库" style="width: 120px" size="small">
                  <a-select-option :value="group.id" v-for="group in titleGroups" :key="group.id" @click="setTitleGroup(group)">
                    {{ group.name }}
                  </a-select-option>
                </a-select>
              </div>
            </a-form-model-item>

            <a-form-model-item label="本地品牌库" prop="brand" >
              <a-select v-model="model.brand"  show-search placeholder="请选择" @change="changeBrand"
                option-filter-prop="children">
                <a-select-option :value="item.name" v-for="item in brands" :key="item.id" :item="item">
                  {{ item.name }}
                </a-select-option>
              </a-select>
              <img v-if="model.brand_cover"  :src="model.brand_cover"  style="height: 100px;margin-top:10px">
            </a-form-model-item>

            <a-form-model-item label="视频素材" prop="materials" >
              <video-select v-model="materials" :advertiser_id="currentAdvId" :num="100" />
            </a-form-model-item>

        </div>

        <div class="step" v-if="current === 4">
          <a-tabs
            default-active-key="1"
            tab-position="left"
            :style="{ height: '800px' }"
          >
            <a-tab-pane v-for="i in getLoopArray(model.campaign_feed_num)" :key="i.toString()" :tab="`计划${i}`">

              <div class="tab-content">

                <a-card  size="small" class="card-tabs" v-for="j in getLoopArray(model.adgroup_feed_num)" :key="j" :title="'广告预览'+j" >
                  <a slot="extra" ></a>

                  <a-tabs type="card" :default-active-key="currentAdvId.toString()" >
                    <a-tab-pane :key="index" v-for="(adv, index) in advs" :tab="adv.name" >
                      <video-select v-model="adv.materials[i-1][j-1]" :advertiser_id="currentAdvId" :num="model.video_num" />
                    </a-tab-pane>
                  </a-tabs>

                </a-card>

              </div>
              
            </a-tab-pane>

          </a-tabs>
        </div>


        <div class="step" v-if="current === 5">
          <a-result
            status="success"
            title="提交成功"
            sub-title="该任务为异步执行，请稍后在任务列表中查看状态"
          >
          </a-result>
        </div>


        <div class="steps-action">
          <a-space class="button-group">
            <template v-if="current < 5">
              <a-button v-if="current === 0" @click="close">取消</a-button>
              <a-button v-if="current > 0" @click="prev">上一步</a-button>
              <a-button v-if="current < steps.length - 2" type="primary" @click="next">下一步</a-button>
              <a-button v-if="current === steps.length - 2" type="primary" @click="submit">提交</a-button>
            </template>

            <template v-if="current === steps.length - 1">
              <a-button :loading="loading" :disabled="loading" @click="close">
                {{ loading ? '任务执行中' : '确认并关闭' }}
              </a-button>
            </template>
          </a-space>

        </div>
      </a-form-model>
    </a-drawer>
  </div>
</template>

<style lang="less" scoped>
@import 'Baidu';
</style>

<script>
import Baidu from './Baidu'
export default Baidu
</script>
